export default __webpack_public_path__ + "static/media/project-placeholder.69bfffe3.png";